<script setup lang="ts">
import BcSidebar from '~/components/navigation/sidebar/Sidebar.vue'
import { useFeatureIndicator } from '~/composables/useFeatureIndicator'
import { menuList } from '~/constants/menu.const'
import { IFeaturedMenuKey, IFeaturedType } from '~/types/featured.type'
import type { MenuType } from '~/types/menu.type'

const route = useRoute()
const { partFeaturedMap } = useFeatureIndicator(IFeaturedMenuKey.SIDEBAR)

const getFeatured = (menuItem: MenuType) => {
  const featuredSet = new Set<IFeaturedType>()
  const featuredType = partFeaturedMap.value?.get(menuItem.key)
  if (featuredType) {
    featuredSet.add(featuredType)
  }
  return Array.from(featuredSet)
}

const parseNavItem = (item: MenuType): MenuType => {
  return {
    ...item,
    isActive: isActive(item),
    featured: [...item.featured, ...getFeatured(item)],
  }
}

const sidebarList = computed<MenuType[]>(() => {
  return menuList.map((item) => {
    const parsedItem = parseNavItem(item)
    if (item.underItems) {
      // 원본 menuList를 수정하지 않고 새 객체에 underItems 할당
      parsedItem.underItems = item.underItems.map((underItem: MenuType) => {
        return parseNavItem(underItem)
      })
    }
    return parsedItem
  })
})

const isActive = (item: MenuType) => {
  const path = route.path
  return !item.external && (
    item.to === path ||
    (item.activeRegex && item.activeRegex.test(path)) ||
    (item.underItems && item.underItems.some(i => i.to === path))
  )
}
</script>

<template>
  <BcSidebar :list="sidebarList" />
</template>

<style scoped>
</style>